var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"9"}},[_c('categorie-index-table')],1),_c('v-col',[_c('categorie-create-form')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }